import { gql } from '@apollo/client';

export const AS2_CONNECTION_STATUS_CHECK = gql`
    query as2ConnectionStatusCheck {
        as2ConnectionStatusCheck
    }
`;
